export default __webpack_public_path__ + "static/media/icon-collective.f29f7e2a.svg";